<template>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a href="javascript:void(0)"
         class="nav-link"
         :class="getTabClasses('prompts')"
         @click="onTabClick('prompts')"
         :style="isDisabled('prompts') ? 'pointer-events: none;' : ''">
        Prompts
      </a>
    </li>
    <li class="nav-item">
      <a href="javascript:void(0)"
         class="nav-link"
         :class="getTabClasses('conversations')"
         @click="onTabClick('conversations')"
         :style="isDisabled('conversations') ? 'pointer-events: none;' : ''">
        {{ sessionsVersion === '2.0' ? 'Sessions' : 'Conversations' }}
      </a>
    </li>
    <li class="nav-item">
      <a href="javascript:void(0)" 
         class="nav-link" 
         :class="getTabClasses('conversation-details')"
         @click="onTabClick('conversation-details')"
         :style="isDisabled('conversation-details') ? 'pointer-events: none;' : ''">
        Details
      </a>
    </li>
    <li class="nav-item">
      <a href="javascript:void(0)" 
         class="nav-link" 
         :class="getTabClasses('analytics-dashboard')"
         @click="onTabClick('analytics-dashboard')"
         :style="isDisabled('analytics-dashboard') ? 'pointer-events: none;' : ''">
        Analytics Dashboard
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'InsightsTabs',
  props: ['viewModel', 'sessionsVersion'],
  data() {
    return {
      model: streetmetrics.model
    }
  },
  methods: {
    isActive(tabLabel) {
      return this.viewModel.childView === tabLabel
    },
    isDisabled(tabLabel) {
      // Check if the tab is disabled in the viewModel
      return this.viewModel.disabledTabs && this.viewModel.disabledTabs.includes(tabLabel)
    },
    getTabClasses(tabLabel) {
      const classes = []
      if (this.isActive(tabLabel)) {
        classes.push('active')
      }
      if (this.isDisabled(tabLabel)) {
        classes.push('disabled')
      }
      return classes
    },
    onTabClick(tabLabel) {
      // Don't emit event if tab is disabled
      if (!this.isDisabled(tabLabel)) {
        this.$emit('tabChangedEvent', tabLabel)
      }
    }
  }
}
</script>

<style>
.nav-link.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #6c757d !important;
}

.nav-link.disabled:hover {
  color: #6c757d !important;
  text-decoration: none;
}
</style> 